const EandW=[
	{
		id: 1,
		title: "DENVER",
		fee: '6,500',
		description: "SAME DAY EVENT",
		detail1: '2 Videographers',
		detail2: '1 minute trailer',
		detail3: '50 min. Full video on a flash drive'
	},
	{
		id: 2,
		title: "MOSCOW",
		fee: '8,000',
		description: "DIFFERENT DAYS EVENT",
		detail1: '3 Videographers and a Drone',
		detail2: '2 min and above trailer',
		detail3: 'Full-length video on a flash drive'
	}
]
export default EandW;